import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './SocialIcons.module.scss';
const SocialIcons = ({ icons, onClick }) => {
    const handleClick = (name) => {
        onClick(name);
    };
    return (_jsx("div", Object.assign({ className: cn('d-flex align-items-center justify-content-end position-relative', styles.element) }, { children: icons.map(({ name, value }) => (_jsx("div", Object.assign({ onClick: () => handleClick(name) }, { children: value }), name))) })));
};
export default SocialIcons;
